<template>
	<main class="single post main" :key="currentPageID" :class="'type-'+currentPostType">
		<template v-if="!isProtected" >
			<SingleHeading />

			<template v-if="currentPage.type === 'venu' && currentPage.acf">
				<div class="container">
					<div class="venu-meta padding-bottom-lg">
						
						<WpImage
							v-if="currentPage.acf && currentPage.acf.venue_logo"
							:image="currentPage.acf.venue_logo"
							size="medium"
							class="image-logo-venue margin-top-lg"
						/>

						<template v-if="currentPage.acf.venue_contact">
							<div class="contact-info margin-top-lg">
								<div class="font--700 text-uppercase lab-title">Kontaktinformasjon</div>
								<a class="font--600 contact-mail jost jost--22" :href="'mailto:' + currentPage.acf.venue_contact">{{currentPage.acf.venue_contact}}</a>
							</div>
						</template>

						<Button v-if="fixedVenueLink" class="color-link venue-btn margin-top-lg" type="green" link hasIcon :outlined="false">
							<AcfLink  :data="fixedVenueLink" />
							<span class="icon">
								<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
							</span>
						</Button>


					</div>
				</div>
			</template>

			<template v-if="currentPage.type === 'events' && currentPage.acf">
				<div class="container">
					<div class="venu-meta padding-bottom-lg">
						<WpImage
							v-if="currentPage.acf.related_venue && relatedVenu[0] && relatedVenu[0].acf && relatedVenu[0].acf.venue_logo"
							:image="relatedVenu[0].acf.venue_logo"
							size="medium"
							class="image-logo-venue margin-top-lg"
						/>

						<template v-if="currentPage.acf.contact_email">
							<div class="contact-info margin-top-lg">
								<div class="font--700 text-uppercase lab-title">Kontaktinformasjon</div>
								<a class="font--600 contact-mail jost jost--22" :href="'mailto:' + currentPage.acf.contact_email">{{currentPage.acf.contact_email}}</a>
							</div>
						</template>

						<Button v-if="fixedVenueLink" class="color-link venue-btn margin-top-lg" type="green" link hasIcon :outlined="false">
							<AcfLink  :data="fixedVenueLink" />
							<span class="icon">
								<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
							</span>
						</Button>

						<Button v-if="currentPage.acf.singup_link && !isPastEvent" class="color-link venue-btn buy-ticket-link margin-top-lg" type="green" link hasIcon :outlined="false">
							<a  target="_blank" title="Kjøp billett" :href="currentPage.acf.singup_link" rel="noopener noreferer">Kjøp billett</a>
							<span class="icon">
								<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
							</span>
						</Button>
						
					</div>
				</div>
			</template>

			<ModuleBuilder />

			<template v-if="currentPage && currentPage.type === 'venu' && connectedEventsToVenue && connectedEventsToVenue.length">
				<div class="related-venu container margin-bottom-xl no-padding-top margin-top-xl">
					<h2 class="titler jost jost--35  text-center font--700">Kommende arrangementer</h2>
					<EventBlock  v-for="post in connectedEventsToVenue" :key="post.id" :post="post" />	
				</div>
			</template>


			<template v-if="currentPage.type === 'events' && currentPage.acf && eventRelatedPosts && eventRelatedPosts.length">
				<div class="related-articles-venue margin-bottom-xl container no-padding-top margin-top-xl">
					<h2 class="titler jost jost--35  text-center font--700">Artikler</h2>
					<PostBlock  :class="{'margin-bottom-sm' : ( i < eventRelatedPosts.length - 1 ) }" list v-for="(post, i) in eventRelatedPosts" :key="post.id" :data="post" />	
				</div>
			</template>

			<template v-if="currentPage.type === 'venu' && currentPage.acf && venuRelatedPosts && venuRelatedPosts.length">
				<div class="related-articles-venue margin-bottom-xl container no-padding-top margin-top-xl">
					<h2 class="titler jost jost--35  text-center font--700">Artikler</h2>
					<PostBlock  :class="{'margin-bottom-sm' : ( i < venuRelatedPosts.length - 1 ) }" list v-for="(post, i) in venuRelatedPosts" :key="post.id" :data="post" />	
				</div>
			</template>

			<template v-if="currentPage && currentPage.type === 'post' && postRelatedEvent && postRelatedEvent.length">
				<div class="related-venu container margin-bottom-xl no-padding-top margin-top-xl">
					<h2 class="titler jost jost--35  text-center font--700">Arrangement</h2>
					<EventBlock  v-for="post in postRelatedEvent" :key="post.id" :post="post" />	
				</div>
			</template>

			<template v-if="currentPage && currentPage.acf && currentPage.acf.related_venue && currentPage.type === 'post' && relatedVenu && relatedVenu.length">
				<div class="related-venu-block-design container margin-bottom-xl no-padding-top margin-top-xl">
						<div class="inner">
						<WpImage
							v-if="relatedVenu[0].acf.venue_logo"
							:image="relatedVenu[0].acf.venue_logo"
							size="medium"
							class="image-logo-venue"
						/>
						<h2 v-else>{{relatedVenu[0].title}}</h2>
						<Button class="color-link venue-btn margin-top-lg" type="green" link hasIcon :outlined="false">
							<WpLink :url="relatedVenu[0].link">Mer informasjon</WpLink>
							<span class="icon">
								<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
							</span>
						</Button>
					</div>
				</div>
			</template>

			<SocialShareArticle />


			<div  v-if="currentPage && currentPage.type === 'venu'" class="bottom-back text-center container">
				<Button class="color-link venue-btn margin-top-lg" type="green" link hasIcon :outlined="false">
					<router-link to="/opplevelser">Se alle opplevelser</router-link>
					<span class="icon">
						<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
					</span>
				</Button>
			</div>

			<RelatedPosts class="related-articles no-padding-top margin-top-xl" v-if="currentPage.type === 'post' && relatedNewsData" :data="relatedNewsData"/>

			<template v-if="currentPage.type === 'events' && currentPage.acf && relatedEvents && relatedEvents.length">
				<div class="related-articles-events container no-padding-top margin-top-xl">
					<h2 class="titler jost jost--35  text-center font--700">Kommende arrangementer</h2>
					<EventBlock  v-for="post in relatedEvents" :key="post.id" :post="post" />	
					
					<div class="relation-link text-center">
					<Button class="color-link venue-btn margin-top-lg" type="green" link hasIcon :outlined="false">
						<router-link to="/opplevelser">Se alle opplevelser</router-link>
						<span class="icon">
							<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
						</span>
					</Button>
					</div>
				</div>
			</template>

			<template v-if="currentPage.type === 'events' && currentPage.acf && (!relatedEvents || !relatedEvents.length)">
				<div class="bottom-back text-center container">
					<Button class="color-link venue-btn margin-top-lg" type="green" link hasIcon :outlined="false">
						<router-link to="/opplevelser">Se alle opplevelser</router-link>
						<span class="icon">
							<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
						</span>
					</Button>
				</div>
			</template>


		</template>
		<PasswordProtection  v-else />
	</main>
</template>


<script>
import ModuleBuilder from '@/components/ModuleBuilder'
import RelatedPosts from '@/components/modules/Posts'
import SocialShareArticle from '@/components/elements/SocialShareArticle'
import VenueBlock from '@/components/elements/VenueBlock'
import EventBlock from '@/components/elements/EventBlock'
import PasswordProtection from '@/components/parts/PasswordProtection'
import SingleHeading from '@/components/parts/SingleHeading'
import WpImage from '@/components/elements/WpImage';
import AcfLink from '@/components/elements/AcfLink'
import WpLink from '@/components/elements/WpLink'
import Button from '@/components/elements/Button'
import PostBlock from '@/components/elements/PostBlock'
import moment  from 'moment' 
moment.locale('nb');    


import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'single-post',
	components:{
		ModuleBuilder,
		PasswordProtection,
		SocialShareArticle,
		RelatedPosts,
		WpImage,
		SingleHeading,
		AcfLink,
		VenueBlock,
		Button,
		EventBlock,
		PostBlock,
		WpLink
	},
	data(){
		return{
			venuRelatedPosts: [],
			relatedVenu: [],
			relatedEvents: [],
			postRelatedEvent: [],
			connectedEventsToVenue: [],
			eventRelatedPosts: []
		}
	},
	methods:{
		...mapActions([
			'getPost',
		]),
		loadPostRelatedEvent(){
			const VM = this;
			
			const options = {
				type: 'events',
				limit : 1,
				single : true,
				include: this.currentPage.acf.related_event
			}
			
			return VM.getPost(options).then(res=>{
				if(res.data && res.data.posts && res.data.posts.length){
					VM.postRelatedEvent = res.data.posts
					return true
				}else{
					return false
				}
			})
		},

		loadEventRelatedPosts(){
			const VM = this;
			const options= {
				type: 'post',
				limit : 20,
				meta: 'related_event',
				value: VM.currentPageID
			}
			
			return VM.getPost(options).then(res=>{
				if(res.data && res.data.posts && res.data.posts.length){
					VM.eventRelatedPosts = res.data.posts
					return true
				}else{
					return false
				}
			})
		},

		loadVenuRelatedPosts(){
			const VM = this;
			const options= {
				type: 'post',
				limit : 20,
				meta: 'related_venue',
				value: VM.currentPageID
			}
			
			return VM.getPost(options).then(res=>{
				if(res.data && res.data.posts && res.data.posts.length){
					VM.venuRelatedPosts = res.data.posts
					return true
				}else{
					return false
				}
			})
		},

		loadConnectedEventsToVenue(){
			const VM = this;
			const options= {
				type: 'events',
				limit : 20,
				meta: 'related_venue',
				value: VM.currentPageID
			}
			
			return VM.getPost(options).then(res=>{
				if(res.data && res.data.posts && res.data.posts.length){
					VM.connectedEventsToVenue = res.data.posts
					return true
				}else{
					return false
				}
			})
		},

		loadUpcommingEvents(){
			const VM = this;
			const options= {
				type: 'events',
				limit : 3, // hehe 
				orderby: 'event_date',
				order: 'DESC',
				exclude: this.currentPage.id
			}
			
			return VM.getPost(options).then( res => {
				if(res.data && res.data.posts && res.data.posts.length){
					VM.relatedEvents = res.data.posts
					return true
				}else{
					return false
				}
			})
		},

		loadPostRelatedVenu(){
			const VM = this;
			
			const options = {
				type: 'venu',
				limit : 1,
				include: this.currentPage.acf.related_venue
			}
			
			return VM.getPost(options).then(res=>{
				if(res.data && res.data.posts && res.data.posts.length){
					VM.relatedVenu = res.data.posts
					return true
				}else{
					return false
				}
			})
		}
	},

	mounted(){
		
		if(this.currentPage && this.currentPage.type === 'events' ){
			this.loadEventRelatedPosts()
		}
		if(this.currentPage && this.currentPage.type === 'post' && this.currentPage.acf.related_event){
			this.loadPostRelatedEvent()
		}
		if(this.currentPage && this.currentPage.type === 'venu'){
			this.loadVenuRelatedPosts()
			this.loadConnectedEventsToVenue()
		}

		if(this.currentPage && ( this.currentPage.type === 'post' || this.currentPage.type === 'events' ) && this.currentPage.acf.related_venue ){
			this.loadPostRelatedVenu()
		}

		if(this.currentPage && this.currentPage.type === 'events' ){
			this.loadUpcommingEvents()
		}
	},

	computed: {
    	...mapGetters([
			'currentPageID',
			'currentPage',
			'currentPostType',
		]),

		isPastEvent(){
			const today =  Number(moment().format("YYYYMMDD"));
			if(this.currentPage && this.currentPage.acf && this.currentPage.acf.event_date){
				return today > Number(this.currentPage.acf.event_date)
			}
			return true
		},
		fixedVenueLink(){
			if(this.currentPage && this.currentPage.type === 'venu' && this.currentPage.acf.venue_link){
				return {
					title: 'Besøk nettsiden',
					target: '_blank',
					url: this.currentPage.acf.venue_link
				}
			}else if(this.currentPage && this.currentPage.type === 'events' && this.relatedVenu && this.relatedVenu[0]){
				return {
					title: 'Mer om arrangøren',
					target: '',
					url: this.relatedVenu[0].link
				}
			}else{
				return false
			}
		},

		arrowIcon(){
           // return arrow('#FFF')
        },

		isProtected(){
			let isProtected = false;
			if(this.currentPage && this.currentPage.is_protected === true){
				isProtected = true
			}
			return isProtected;
		},

		relatedVenuePosts(){
			return this.venuRelatedPosts
		},
		
		relatedNewsData(){
			if(!this.currentPageID) return null;
			let title = this._('Andre aktuelt');
			
			return {
				title,
				type: this.currentPostType,
				limit: 4,  //some bug in api .... due to exclude ... ?
				exclude : [this.currentPageID],
			}
		},
	}
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.related-articles-venue, .related-venu{
	max-width: 860px;
}

.related-venu-block-design{
	.inner{
		margin: 0 auto;
		padding: 60px;
		max-width: 800px;
		border: 10px solid $green;
		text-align: center;
		h2{
			margin: 0;
		}
	}
}

.single.post{
	.contact-info{
		.contact-mail{
			display: inline-block;
			margin-top: 10px
		}
	}
	.venu-meta{
		display: flex;
		align-items: center;
		flex-direction: column;
		text-align: center;
		border-bottom: 2px solid $dark;
	}

}

</style>